/**
 * @generated SignedSource<<cb11dc4636b47738b815410ba3df4146>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type State_geographySalesforce$data = {
  readonly states: ReadonlyArray<{
    readonly abbreviation: string | null;
    readonly name: string | null;
  } | null> | null;
  readonly " $fragmentType": "State_geographySalesforce";
};
export type State_geographySalesforce$key = {
  readonly " $data"?: State_geographySalesforce$data;
  readonly " $fragmentSpreads": FragmentRefs<"State_geographySalesforce">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "State_geographySalesforce",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "countryCode",
          "value": "US"
        }
      ],
      "concreteType": "states",
      "kind": "LinkedField",
      "name": "states",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "abbreviation",
          "storageKey": null
        }
      ],
      "storageKey": "states(countryCode:\"US\")"
    }
  ],
  "type": "GeographySalesforce",
  "abstractKey": null
};

(node as any).hash = "c4b8cd5f8b346d1953cab39e577831c8";

export default node;
